import React, { useState, useEffect, useMemo } from 'react';
import MemberCard from '../../components/MemberCard/MemberCard';
import SEO from '../../components/SEO/SEO';
import DonateModal from '../../components/ui/DonateModal';

const SilverMembers = () => {
  const [apiMembers, setApiMembers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [isModalOpen, setIsModalOpen] = useState(false);

  // Google Form URL - update this with your actual form URL
  const GOOGLE_FORM_URL = 'https://docs.google.com/forms/d/e/1FAIpQLSd-7Qz-U_Blbk8LkXXUKW28zMUMmIUY_KJBAGt1dRIqP9e75Q/viewform?usp=dialog';

  // Static members data - memoized to prevent recreating on every render
  const staticMembers = useMemo(() => [
    { 
      id: '001', 
      name: 'Eng. Mahesh Dilroy Paranamanage', 
      image: 'https://i.imgur.com/WPzvILe.jpeg',
      batchYear: '1st Batch',
      currentWork: 'Civil Engineering Consultant',
      location: 'United Kingdom',
      socialMedia: {
        facebook: '',
        linkedin: ''
      }
    },
    { 
      id: '002', 
      name: 'Dr. Nuwan Weerasinghe', 
      image: 'https://i.imgur.com/5jW2lv9.jpeg',
      batchYear: '1st Batch',
      currentWork: 'IT Consultant and Entrepreneur - IScientia Ltd',
      location: 'London United Kingdom',
      socialMedia: {
        facebook: '',
        linkedin: ''
      }
    },
    { 
      id: '003', 
      name: 'Dr. Jcs Kadupitiya', 
      image: 'https://i.imgur.com/DWu1jwG.jpeg',
      batchYear: '12th Batch',
      currentWork: 'Software Engineer at Microsoft',
      // location: 'Colombo',
      socialMedia: {
        facebook: '',
        linkedin: 'linkedin.com/in/kadupitiya?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'
      }
    },
    { 
      id: '004', 
      name: 'Eng. Janaka Ransiri Sowis', 
      image: '',
      batchYear: '1st Batch',
      currentWork: 'Managing Director - Civil Engineer HPIS (Pvt) Ltd',
      location: 'Colombo',
      socialMedia: {
        facebook: '',
        linkedin: ''
      }
    },
    { 
      id: '005', 
      name: 'Eng. Asanka Vajira Kamburapola', 
      image: 'https://i.imgur.com/Sqoaq4g.jpeg',
      batchYear: '1st Batch',
      currentWork: 'Executive Director- ICC PNG Limited',
      location: '',
      socialMedia: {
        facebook: '',
        linkedin: ''
      }
    },
    { 
      id: '006', 
      name: 'Eng. Gemunu Vidana Gamage', 
      image: 'https://i.imgur.com/fK6S1hE.jpeg',
      batchYear: '1st Batch',
      currentWork: 'Senior Engineer - Electrical Design Engineering',
      location: 'Australia',
      socialMedia: {
        facebook: 'https://www.facebook.com/vggemunu',
        linkedin: 'https://www.linkedin.com/in/gemunu-vidana-gamage-16473724/'
      }
    },
    { 
      id: '007', 
      name: 'Eng. Sugeesh Madurapperuma', 
      image: 'https://i.imgur.com/2W5PDsG.jpeg',
      batchYear: '1st Batch',
      currentWork: 'Service Delivery Manager at Genus Group',
      location: 'Melbourne, Australia',
      socialMedia: {
        facebook: 'https://www.facebook.com/share/17Cj5nfFPF/?mibextid=wwXIfr',
        linkedin: 'https://www.linkedin.com/in/sugeesh-madurapperuma-090225a7?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'
      }
    },
    { 
      id: '008', 
      name: 'Eng. Chawan Prasad Gunawardhane', 
      image: 'https://i.imgur.com/ajler2H.jpeg',
      batchYear: '1st Batch',
      currentWork: 'Senior Operation Engineer (East), Central Engineering Services (pvt) Ltd.',
      location: 'Kandy',
      socialMedia: {
        facebook: '',
        linkedin: ''
      }
    },
    { 
      id: '009', 
      name: 'Eng. Jagath Kumara', 
      image: 'https://i.imgur.com/AppELkd.jpeg',
      batchYear: '1st Batch',
      currentWork: 'Director- Jagath Engineering Power (Pvt) Ltd',
      location: 'Bandaragama',
      socialMedia: {
        facebook: 'https://www.facebook.com/share/14RkENpJ6bs/',
        linkedin: 'https://www.linkedin.com/in/jagath-kumara-63292429/'
      }
    },
    { 
      id: '010', 
      name: 'Dr. Isuru Udara Wickramasinghe', 
      image: 'https://i.imgur.com/DEOylvE.jpeg',
      batchYear: '6th Batch',
      currentWork: '',
      location: '',
      socialMedia: {
        facebook: '',
        linkedin: 'https://www.linkedin.com/in/isu-wickramasinghe?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'
      }
    },
    { 
      id: '011', 
      name: 'Eng. Wikum Wijesekara', 
      image: 'https://i.imgur.com/aBzx19p.jpeg',
      batchYear: '6th Batch',
      currentWork: 'Mechanical Engineer-Project Engineer',
      location: 'New Zealand',
      socialMedia: {
        facebook: '',
        linkedin: 'http://linkedin.com/in/wikum-wijesekara-5728a423'
      }
    },
    { 
      id: '012',
      join_id : '1', 
      name: 'Dr. Singithi Himashini De Silva', 
      image: 'https://i.imgur.com/cREOZ9u.jpeg',
      batchYear: '6th Batch',
      currentWork: 'Software Engineer',
      location: 'Australia',
      socialMedia: {
        facebook: '',
        linkedin: 'https://www.linkedin.com/in/singithi-de-silva-914260b?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'
      }
    },
    { 
      id: '013',
      join_id : '1', 
      name: 'Dr. Kalana Withanage', 
      image: 'https://i.imgur.com/b3676wS.jpeg',
      batchYear: '6th Batch',
      currentWork: 'AI Solution Architect',
      location: 'Australia',
      socialMedia: {
        facebook: '',
        linkedin: 'https://www.linkedin.com/in/kalanaishara?utm_source=share&utm_campaign=share_via&utm_content=profile&utm_medium=ios_app'
      }
    },
    { 
      id: '014', 
      join_id : '2', 
      name: 'Eng. Sasika Rathnaweera', 
      image: 'https://i.imgur.com/iyKbtWI.jpeg',
      batchYear: '6th Batch',
      currentWork: 'Managing Director at Statewide Geotechnical',
      location: 'Australia',
      socialMedia: {
        facebook: '',
        linkedin: 'http://linkedin.com/in/sasika-rathnaweera-88111938'
      }
    },
    { 
      id: '015', 
      join_id : '2', 
      name: 'Dr. Gayan Rathnaweera', 
      image: 'https://i.imgur.com/1yOVHxt.jpeg',
      batchYear: '4th Batch',
      currentWork: 'Co-Owner and Business Development Manager at Statewide Geotechnical',
      location: 'Australia',
      socialMedia: {
        facebook: '',
        linkedin: 'http://linkedin.com/in/gayan-rathnaweera-b1367337'
      }
    },
  ], []);

  // Fetch members from Google Sheets API
  useEffect(() => {
    const fetchApiMembers = async () => {
      try {
        const response = await fetch('https://script.google.com/macros/s/AKfycbzJgRfmV7d148ng9nJ1rXCajnLDl3g2sfxLJcO5H5-zN_MoNlZsR3ky2fAb8AIRhflT/exec');
        const result = await response.json();
        
        if (result.success && result.data) {
          // Get the last static member ID number
          const lastStaticId = parseInt(staticMembers[staticMembers.length - 1].id);
          
          // Update IDs for API members to continue from static members
          const newApiMembers = result.data.map((member, index) => ({
            ...member,
            id: String(lastStaticId + index + 1).padStart(3, '0')
          }));
          
          setApiMembers(newApiMembers);
        }
      } catch (error) {
        console.error('Error fetching members from API:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchApiMembers();
  }, [staticMembers]);

  // Combine static and API members
  const allMembers = [...staticMembers, ...apiMembers];

  // Group members by join_id and prepare for rendering
  const prepareMembers = () => {
    const grouped = [];
    const processed = new Set();

    allMembers.forEach((member, index) => {
      if (processed.has(index)) return;

      // If member has join_id, find all members with the same join_id
      if (member.join_id) {
        const jointMembers = allMembers.filter((m, i) => 
          m.join_id === member.join_id && !processed.has(i)
        );
        
        // Mark all joint members as processed
        jointMembers.forEach(jm => {
          const idx = allMembers.findIndex(m => m.id === jm.id);
          processed.add(idx);
        });

        // Add as a joint donation group
        grouped.push({ type: 'joint', members: jointMembers });
      } else {
        // Add as individual member
        processed.add(index);
        grouped.push({ type: 'single', member });
      }
    });

    return grouped;
  };

  const groupedMembers = prepareMembers();

  // Chunk members into rows of 4 (considering joint donations take space)
  const chunkedMembers = [];
  let currentRow = [];
  let currentRowSlots = 0;

  groupedMembers.forEach((item) => {
    const slotsNeeded = item.type === 'joint' ? item.members.length : 1;

    // If adding this item exceeds 4 slots, start a new row
    if (currentRowSlots + slotsNeeded > 4) {
      if (currentRow.length > 0) {
        chunkedMembers.push(currentRow);
      }
      currentRow = [item];
      currentRowSlots = slotsNeeded;
    } else {
      currentRow.push(item);
      currentRowSlots += slotsNeeded;
    }
  });

  // Add the last row if it has items
  if (currentRow.length > 0) {
    chunkedMembers.push(currentRow);
  }

  return (
    <>
      <SEO 
        title="Silver Members - 25th Anniversary"
        description="Celebrating our proud graduates who have established a lasting legacy through the Student Welfare Fund, providing vital scholarships for bright students."
      />
      
      <div className="w-full bg-Color-White flex flex-col justify-start items-center overflow-hidden">
        {/* Hero Section */}
        <div className="relative w-full max-w-[1920px] px-4 sm:px-6 md:px-12 lg:px-[100px] py-6 sm:py-8 lg:py-10 flex flex-col lg:flex-row justify-center items-start gap-4 lg:gap-0">
          {/* Background with gradient overlay */}
          <div 
            className="absolute inset-0 pointer-events-none"
            style={{
              backgroundImage: 'url(/silver-flow.webp)',
              backgroundSize: 'cover',
              backgroundPosition: 'center'
            }}
          >
            <div className="absolute inset-0 bg-gradient-to-r from-black/40 to-black/0" />
          </div>

          {/* Event Title Container */}
          <div className="relative flex-1 min-w-0 flex flex-col gap-1 sm:gap-1 lg:gap-1 items-start py-2 sm:py-3 lg:py-4">
            <div className="w-full font-['Montserrat'] font-normal text-[32px] sm:text-[48px] md:text-[56px] lg:text-[64px] text-white tracking-[-0.64px] leading-tight">
              <p className="mb-0 leading-tight">Silver</p>
              <p className="font-semibold underline decoration-solid [text-underline-position:from-font] [text-decoration-skip-ink:none] leading-tight">
                Members
              </p>
            </div>
          </div>

          {/* Event Description Container */}
          <div className="relative flex-1 min-w-0 max-w-full lg:max-w-[720px] lg:pl-10 py-2 sm:py-3 lg:py-4 flex flex-col gap-4 sm:gap-6 lg:gap-8 items-start">
            <div className="w-full backdrop-blur-md bg-white/80 rounded-lg p-3 sm:p-4 flex gap-2 items-center justify-center">
              <p className="flex-1 font-['Montserrat'] font-medium text-xs sm:text-sm md:text-base text-Color-Black tracking-[0.16px] leading-normal">
                To celebrate our 25th Anniversary, we invite our proud graduates to establish a lasting legacy. By becoming a Silver Member of the Student Welfare Fund, your generous donation provides vital scholarships for bright students from challenging backgrounds. Reconnect with Ruhuna and help us ensure the next generation of engineers is limited only by their potential, not their means.
              </p>
            </div>
          </div>
        </div>

        {/* Members Grid Section */}
        <div className="w-full px-4 sm:px-6 md:px-12 lg:px-[100px] py-8 sm:py-12 lg:py-16 flex flex-col justify-start items-start gap-4 sm:gap-6 overflow-clip">
          <div className="w-full font-['Montserrat'] font-bold text-lg sm:text-xl md:text-2xl text-black tracking-[0.24px] uppercase leading-none">
            Meet the Architects of Opportunity
          </div>

          {/* Members Grid - Supports Joint Donations */}
          {chunkedMembers.map((row, rowIndex) => (
            <div 
              key={`row-${rowIndex}`}
              className="w-full px-0 py-2 sm:py-3 lg:py-4 grid grid-cols-2 sm:grid-cols-2 lg:grid-cols-4 gap-4 sm:gap-6 lg:gap-8 xl:gap-10"
            >
              {row.map((item, itemIndex) => {
                if (item.type === 'joint') {
                  // Render joint donation group with shared border
                  return (
                    <div
                      key={`joint-${rowIndex}-${itemIndex}`}
                      className="relative border-2 rounded-lg p-3 sm:p-4"
                      style={{
                        gridColumn: `span ${item.members.length}`,
                        borderColor: '#C0C0C0'
                      }}
                    >
                      {/* Joint Donation Label */}
                      <div className="absolute -top-3 left-4 bg-white px-2">
                        <span className="font-['Montserrat'] font-semibold text-xs sm:text-sm uppercase tracking-wide"
                          style={{ color: '#A8A8A8' }}
                        >
                          Joint Donation
                        </span>
                      </div>
                      
                      {/* Cards side by side */}
                      <div className="grid gap-4 sm:gap-6 lg:gap-8 xl:gap-10"
                        style={{
                          gridTemplateColumns: `repeat(${item.members.length}, 1fr)`
                        }}
                      >
                        {item.members.map((member) => (
                          <MemberCard
                            key={member.id}
                            name={member.name}
                            memberId={member.id}
                            imageUrl={member.image}
                            batchYear={member.batchYear}
                            currentWork={member.currentWork}
                            location={member.location}
                            socialMedia={member.socialMedia}
                          />
                        ))}
                      </div>
                    </div>
                  );
                } else {
                  // Render individual member card
                  const member = item.member;
                  return (
                    <MemberCard
                      key={member.id}
                      name={member.name}
                      memberId={member.id}
                      imageUrl={member.image}
                      batchYear={member.batchYear}
                      currentWork={member.currentWork}
                      location={member.location}
                      socialMedia={member.socialMedia}
                    />
                  );
                }
              })}
            </div>
          ))}

          {/* Loading indicator for API members */}
          {loading && (
            <div className="w-full px-0 py-8 flex justify-center items-center">
              <div className="font-['Montserrat'] text-base text-Color-Brand animate-pulse">
                Loading more members...
              </div>
            </div>
          )}
        </div>

        {/* Join the Legacy Section */}
        <div className="w-full px-4 sm:px-6 md:px-12 lg:px-20 py-8 sm:py-10 lg:py-12 flex justify-center items-start overflow-clip">
          <div className="flex-1 min-w-0 border-l-2 border-Color-Brand px-4 sm:px-5 lg:px-6 py-3 sm:py-3.5 lg:py-4 flex flex-col lg:flex-row justify-start items-start lg:items-center gap-6 sm:gap-8 lg:gap-16 xl:gap-[100px]">
            {/* Title */}
            <div className="flex-1 min-w-0 font-['Montserrat'] font-normal text-[32px] sm:text-[48px] md:text-[56px] lg:text-[64px] text-Color-Black tracking-[-0.64px] leading-tight">
              <p className="mb-0">Join the</p>
              <p className="font-semibold text-Color-Brand underline decoration-solid [text-underline-position:from-font] [text-decoration-skip-ink:none]">
                Legacy
              </p>
            </div>

            {/* Content */}
            <div className="flex flex-col gap-6 sm:gap-7 lg:gap-8 items-start justify-center p-0 w-full lg:w-auto">
              <div className="w-full lg:w-[580px] font-['Montserrat'] font-semibold text-xs sm:text-sm md:text-base text-black capitalize tracking-[0.16px] leading-normal">
                Your support is the most powerful investment we can make in the future of our faculty. Learn how you can become a Silver Member and leave a lasting legacy in the lives of our future engineers.
              </div>
              
              {/* CTA Button - Opens Modal */}
              <button
                onClick={() => setIsModalOpen(true)}
                className="px-8 py-4 bg-gradient-to-r from-Color-Brand to-Color-Primary hover:from-Color-Primary hover:to-Color-Brand text-white font-['Montserrat'] font-bold text-base rounded-lg shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105"
              >
                DONATE NOW
              </button>
            </div>
          </div>
        </div>

        {/* Donate Modal */}
        <DonateModal 
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
          formUrl={GOOGLE_FORM_URL}
        />
      </div>
    </>
  );
};

export default SilverMembers;
